
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/portals",
      function () {
        return require("private-next-pages/info/portals.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/portals"])
      });
    }
  